/* eslint-disable @typescript-eslint/no-empty-function */
import { FormRules } from "element-plus"
import XForm from '@/components/x-form/XForm.vue'
import { BaseForm } from "./BaseForm"

/**
 *表单
 * @export
 * @class EditForm
 */
export class EditForm extends BaseForm {
  /**
   * 构造搜索表单
   * @param el 挂载节点
   * @param items 表单项
   * @param elFormProps el-form属性
   * @param saveUrl 保存的url
   * @param loadUrl 加载的url
   * @param loaded 是否启用加载状态
   * @param saveMethods 保存请求方式
   */
  constructor(
    el: Element,
    items: (FormItem | null)[][],
    elFormProps?: FormProps<FormRules>,
    saveUrl?: string,
    loadUrl?: string,
    loaded?: boolean,
    saveMethods?: 'post' | 'put'
  ) {
    super(el, XForm as VueComponent, {
      items,
      elFormProps,
      saveUrl,
      loadUrl,
      loaded: loaded === false ? false : true,
      saveMethods: saveMethods || 'post',
    })
  }

  /**
   * 保存
   *
   * @param success 保存成功后的回调
   * @param error 保存失败后的回调
   * @memberof EditForm
   */
  save(success?: (formdata?: any) => void, error?: () => void, validateFail?: () => void) {
    if(this.controller) {
      return this.controller.save(success, error,validateFail)
    }
  }
  
  /**
   * 保存时的额外参数
   */
  setSaveParams(data: any) {
    if(this.controller) {
      return this.controller.setSaveParams(data)
    }
  }

  /**
   * 加载数据
   * @param data 数据
   * @returns 
   */
  load(data: any): Promise<any> {
    if(this.controller) {
      return this.controller.load(data)
    }
    return Promise.reject(false)
  }
}

